@for (option of options; track option) {
  <div
    class="accessible-skip-link"
    >
    @if (option.domElement) {
      <a
        role="link"
        class="goreact-btn primary-btn skip-link-btn"
      href="#{{option.id}}">{{option.linkText}}</a>
    }
  </div>
}
